import { RestService } from "./RestService";

export class MovieMarathonService extends RestService {
  constructor() {
    super("/api/v1/movie_marathons");
  }
}
